'use client';

import React, { useEffect, useState } from 'react';
import { Button, Typography, Grow, Fade, Link } from '@mui/material';
import Stepper from './elements/stepper';
import Heading from './elements/heading';
import { EventBus } from '@/shared/utils';
import { OnboardingEventKeys, OnboardingEvents } from '../events';
import { RadioOptionGroup } from './radio-option-group';
import { Instrument } from '../types';

interface InstrumentsChildSelectionProps {
  eventBus: EventBus<OnboardingEvents>;
  childInstruments: Instrument[]; // array dei child
}

const InstrumentsChildSelection: React.FC<InstrumentsChildSelectionProps> = ({
  eventBus,
  childInstruments,
}) => {
  const [selectedRadio, setSelectedRadio] = useState<string>('');
  const [parentName, setParentName] = useState<string>(''); // Stato per il parentName
  const handleRadioChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSelectedRadio(event.target.value);
  };

  const handleBack = () => {
    // Emettiamo l’evento di “Indietro”
    eventBus.emit(OnboardingEventKeys.instrument.child.back, undefined);
  };

  const handleContinue = () => {
    if (!selectedRadio) return;
    // Emettiamo l’evento di selezione child
    eventBus.emit(OnboardingEventKeys.instrument.child.do, {
      childName: selectedRadio,
    });
  };

  useEffect(() => {
    // Ascoltiamo l'evento per ottenere il parentName
    const handleChildView = (payload: { parentName: string }) => {
      setParentName(payload.parentName);
    };

    eventBus.on(OnboardingEventKeys.instrument.child.view, handleChildView);

    return () => {
      eventBus.off(OnboardingEventKeys.instrument.child.view, handleChildView);
    };
  }, [eventBus]);
  return (
    <>
      <Fade in={true}>
        <div>
          <Stepper activeStep={0} />
        </div>
      </Fade>

      <section className="flex flex-col pt-10 pb-12 gap-y-8 items-center max-w-[700px] m-auto text-center">
        <Fade in={true} style={{ transitionDuration: '700ms' }}>
          <div>
            <Heading
              title="Quale strumento ti interessa?"
              subtitle="Scegli il tuo strumento preferito. Ci aiuterà a capire quali contenuti mostrarti."
            >
              {!!selectedRadio && (
                <div>
                  <Link href="#" underline="none" variant="button-s">
                    {parentName}
                  </Link>
                  {' > '}{' '}
                  <Link href="#" underline="none" variant="button-s">
                    {selectedRadio}
                  </Link>
                </div>
              )}
            </Heading>
          </div>
        </Fade>

        <Grow in={true} style={{ transformOrigin: 'center center' }}>
          <div className="w-full space-y-4">
            <div className="space-y-4 w-full">
              <RadioOptionGroup
                options={childInstruments.map((child) => child.instrumentName)}
                value={selectedRadio}
                labelClass="flex justify-between"
                labelPlacement="start"
                onChange={handleRadioChange}
              />
            </div>
            {/* <div className="flex mx-auto mt-4 gap-2 justify-center w-[40px]">
              <ProgressIndicator steps={2} currentStep={1} />
            </div> */}
          </div>
        </Grow>

        <Grow in={true} style={{ transformOrigin: 'center center' }}>
          <div className="flex flex-wrap gap-4 justify-center">
            <Button
              size="large"
              variant="outlined"
              color="primary"
              className="max-w-full w-[220px]"
              onClick={handleBack}
            >
              <Typography variant="button-l">Indietro</Typography>
            </Button>
            <Button
              size="large"
              variant="contained"
              color="primary"
              className="max-w-full w-[220px]"
              disabled={!selectedRadio}
              onClick={handleContinue}
            >
              <Typography variant="button-l">Continua</Typography>
            </Button>
          </div>
        </Grow>
      </section>
    </>
  );
};

export default InstrumentsChildSelection;
